<template>
  <button class="cancel-order-btn" type="button" :disabled="cancelling" @click.stop.prevent="confirmVisible = true">
    {{ cancelling ? '正在取消' : '取消订单' }}
  </button>

  <Teleport to="body">
    <div v-if="confirmVisible" class="cancel-order-mask" @click.self="closeConfirm">
      <section class="cancel-order-dialog" role="dialog" aria-modal="true" aria-labelledby="cancel-order-title">
        <h2 id="cancel-order-title">取消这个订单？</h2>
        <p>{{ confirmText }}</p>
        <div class="dialog-actions">
          <button type="button" :disabled="cancelling" @click="closeConfirm">再想想</button>
          <button type="button" :disabled="cancelling" @click="cancelOrder">
            {{ cancelling ? '正在取消' : '确认取消' }}
          </button>
        </div>
      </section>
    </div>
  </Teleport>
</template>

<script setup>
import { computed, ref } from 'vue'
import { showToast } from 'vant'
import { cancelWebsiteOrder } from '@/api/trade'

const props = defineProps({
  order: { type: Object, required: true }
})

const emit = defineEmits(['canceled'])

const confirmVisible = ref(false)
const cancelling = ref(false)
const paidOrder = computed(() => Number(props.order.payStatus) === 1)
const confirmText = computed(() => paidOrder.value
  ? '该订单已支付。取消后将关闭订单并进入退款处理，已支付金额以退款结果为准。'
  : '取消后将关闭当前订单，未支付订单不会产生扣款。')

function closeConfirm() {
  if (cancelling.value) return
  confirmVisible.value = false
}

async function cancelOrder() {
  cancelling.value = true
  try {
    const result = await cancelWebsiteOrder(props.order.id)
    if (result === false) {
      showToast('订单状态已变化，请刷新后重试')
      confirmVisible.value = false
      emit('canceled')
      return
    }
    showToast('订单已取消')
    confirmVisible.value = false
    emit('canceled')
  } catch (error) {
    showToast(error.message || '订单取消失败')
  } finally {
    cancelling.value = false
  }
}
</script>

<style scoped>
.cancel-order-btn { min-height: 34px; display: inline-flex; align-items: center; justify-content: center; padding: 0 13px; border: 1px solid rgba(255,156,156,.28); border-radius: 999px; color: #ff9c9c; font-size: 11.5px; font-weight: 800; background: rgba(255,156,156,.07); }
.cancel-order-btn:active { background: rgba(255,156,156,.14); }
.cancel-order-btn:disabled { opacity: .55; }
.cancel-order-mask { position: fixed; inset: 0; z-index: 100; display: flex; align-items: center; justify-content: center; padding: 22px; background: rgba(1,4,10,.74); backdrop-filter: blur(6px); }
.cancel-order-dialog { width: min(100%, 360px); display: grid; gap: 12px; padding: 20px 18px; border: 1px solid var(--mobile-line-strong); border-radius: 18px; background: linear-gradient(165deg, rgba(18,31,52,.98), rgba(7,15,29,.99)); box-shadow: 0 20px 52px rgba(0,0,0,.42); }
.cancel-order-dialog h2 { color: var(--mobile-ink); font-size: 17px; font-weight: 900; }
.cancel-order-dialog p { color: var(--mobile-muted); font-size: 12px; line-height: 1.75; }
.dialog-actions { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; margin-top: 2px; }
.dialog-actions button { min-height: 44px; border-radius: 12px; font-size: 13.5px; font-weight: 800; }
.dialog-actions button:first-child { border: 1px solid var(--mobile-line-strong); color: var(--mobile-muted); background: rgba(255,255,255,.04); }
.dialog-actions button:last-child { color: #ffd9d9; background: rgba(226,90,90,.82); }
.dialog-actions button:disabled { opacity: .6; }
</style>
